"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const NavigationWrapperWeb_1 = __importDefault(require("../common/NavigationWrapperWeb"));
const react_1 = require("react");
const selectors_1 = require("../../store/redux/selectors");
const react_redux_1 = require("react-redux");
const native_1 = require("@react-navigation/native");
const ChatFooter_1 = __importDefault(require("./ChatFooter"));
const GoBack_1 = __importDefault(require("../common/GoBack"));
const react_i18next_1 = require("react-i18next");
const dictionaries_1 = require("../../services/dictionaries");
const messageHelper_1 = require("../../services/messageHelper");
const FlightRedirectorWeb_1 = __importDefault(require("./FlightRedirectorWeb"));
const UserRedirectorWeb_1 = __importDefault(require("./UserRedirectorWeb"));
const MessageBubbleWeb_1 = __importDefault(require("./MessageBubbleWeb"));
const LoadMessagesWidget_1 = __importDefault(require("./LoadMessagesWidget"));
const config_1 = require("../../config/config");
const ChatWeb = () => {
    const currentChat = (0, react_redux_1.useSelector)(selectors_1.getCurrentChat);
    const userDetails = (0, react_redux_1.useSelector)(selectors_1.getUser);
    const currentToken = (0, react_redux_1.useSelector)(selectors_1.getAccessToken);
    const navigation = (0, native_1.useNavigation)();
    const [t] = (0, react_i18next_1.useTranslation)("i18n");
    const [update, setUpdate] = (0, react_1.useState)(false);
    const [reconnectInfo, setReconnectInfo] = (0, react_1.useState)(false);
    const { receiver: currentReceiverData, initiator: currentInitiatorData, next_page: nextPage, messages_count: currentMessagesCount, messages: currentMessages, flight: currentFlightData, isGroupChat: isGroupChat } = currentChat;
    const wsClient = (0, react_1.useRef)(new WebSocket(isGroupChat ?
        `${config_1.API_URL.replace('http', 'ws')}chat/ws?flight_id=${currentFlightData?.id}&user_id=${userDetails?.id}&token=${currentToken}`
        :
            `${config_1.API_URL.replace('http', 'ws')}chat/ws?user_id=${userDetails?.id}&initiator_id=${currentInitiatorData?.id}&receiver_id=${currentReceiverData?.id}&token=${currentToken}`));
    const numberOfPages = (0, messageHelper_1.getNumberOfPages)(currentMessagesCount, currentMessages);
    const handleNavigationChange = () => {
        (0, messageHelper_1.closeWebSocket)(wsClient);
    };
    const unsubscribeFocus = navigation.addListener('beforeRemove', handleNavigationChange);
    (0, react_1.useEffect)(() => {
        if (userDetails?.language)
            (0, messageHelper_1.updateCalendar)(userDetails.language, t("messages.yesterday"), t("messages.today"));
    }, [userDetails]);
    (0, react_1.useEffect)(() => {
        return (0, messageHelper_1.handleWebSocketConnection)({
            currentChat,
            navigateToMessages: () => navigation.navigate("Messages"),
            userDetails,
            currentFlightData,
            wsClient,
            currentInitiatorData,
            currentReceiverData,
            currentToken,
            setReconnectInfo,
            setUpdate,
            update
        });
    }, [update]);
    (0, react_1.useEffect)(() => {
        return () => {
            (0, messageHelper_1.closeWebSocket)(wsClient);
            unsubscribeFocus();
        };
    }, [navigation]);
    return ((0, jsx_runtime_1.jsxs)(NavigationWrapperWeb_1.default, { children: [(0, jsx_runtime_1.jsx)(GoBack_1.default, { onBack: () => navigation.goBack(), showShare: false }), (0, jsx_runtime_1.jsxs)("div", { className: "chat-container", children: [currentFlightData ?
                        (0, jsx_runtime_1.jsx)(FlightRedirectorWeb_1.default, { flightData: currentFlightData })
                        :
                            (0, jsx_runtime_1.jsx)(UserRedirectorWeb_1.default, { receiverData: currentReceiverData, initiatorData: currentInitiatorData }), (0, jsx_runtime_1.jsx)("div", { className: "chat-divider" }), (0, jsx_runtime_1.jsx)("div", { className: "chat-wrapper", children: (0, jsx_runtime_1.jsxs)("div", { className: "chat", children: [numberOfPages && numberOfPages > 1 &&
                                    (0, jsx_runtime_1.jsx)(LoadMessagesWidget_1.default, { numberOfPages: numberOfPages, flightData: currentFlightData, receiverData: currentReceiverData, initiatorData: currentInitiatorData, nextPage: nextPage }), currentMessages?.map((message, index) => (0, jsx_runtime_1.jsx)(MessageBubbleWeb_1.default, { message: message, content: message.content, sender: message.sender?.id === userDetails?.id }, `Message${message.id}Index${index}`)), currentFlightData && currentFlightData.status === dictionaries_1.FlightStatus.CANCELED &&
                                    (0, jsx_runtime_1.jsxs)("div", { className: "error-message info", children: [t("details.cancelled_flight"), ": ", currentFlightData.cancel_message ? currentFlightData.cancel_message : t("details.pilot_deleted_account")] }), reconnectInfo &&
                                    (0, jsx_runtime_1.jsx)("div", { className: "info reconnect-loading", children: t("messages.reconnecting") })] }) }), (0, jsx_runtime_1.jsx)(ChatFooter_1.default, { user: userDetails, flightData: currentFlightData, messagesCount: currentMessagesCount, receiverData: currentReceiverData, initiatorData: currentInitiatorData, nextPage: nextPage, socket: wsClient.current, reconnect: reconnectInfo })] })] }));
};
exports.default = ChatWeb;
